'use strict';
export class Menu {

    constructor() {
    }

    public init() : void {

        if(document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', this.onContentLoaded);
        }
        else {
            this.onContentLoaded();
        }
    }

    private onContentLoaded() {
        // Get all "navbar-burger" elements
        var $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);

        // Check if there are any navbar burgers
        if ($navbarBurgers.length > 0) {

            // Add a click event on each of them
            $navbarBurgers.forEach(function ($el: HTMLElement) {
                $el.addEventListener('click', function () {

                    // Get the target from the "data-target" attribute
                    let target: string|undefined = $el.dataset.target;
                    if(target !== undefined) {
                        let $targetElement = document.getElementById(target);

                        if($targetElement !== undefined) {
                            // Toggle the class on both the "navbar-burger" and the "navbar-menu"
                            $el.classList.toggle('is-active');
                            $targetElement!.classList.toggle('is-active');
                        }
                    }

                });
            });
        }
    }
}